document.addEventListener("alpine:init", () => {
  Alpine.data("ThemeModule_CartProgress", () => {
    return {
      progress: 0,
      maxThreshold: window.freeShippingThreshold,
      freeGiftThreshold: 3000,
      cartTotal: 0,
      hasReachedFreeShipping: false,
      hasReachedFreeGift: false,
      init() {
        this.initializeProgress();

        window.addEventListener(
          "shapes:modalcart:cartqtychange",
          this.handleCartUpdate.bind(this)
        );

        window.addEventListener(
          "shapes:modalcart:afteradditem",
          this.handleCartUpdate.bind(this)
        );

        window.addEventListener(
          "shapes:modalcart:opened",
          this.initializeProgress.bind(this)
        );

        window.addEventListener("cart:updated", (e) => {
          this.cartTotal = this.cartTotal || 0;
          this.hasReachedFreeShipping = this.cartTotal >= this.maxThreshold;
          this.hasReachedFreeGift = this.cartTotal >= this.freeGiftThreshold;
          this.handleCartUpdate.bind(this);
          this.updateProgress(this.cartTotal);
        });

        this.$watch("cartTotal", (value) => {
          this.updateProgress(value);
        });

        this.$watch("hasReachedFreeShipping", (value) => {
          if (value) {
            this.progress = 100;
          } else {
            this.progress = this.calculateProgressFromTotal(this.cartTotal);
          }
        });
      },
      initializeProgress() {
        this.maxThreshold = parseInt(window.freeShippingThreshold);
        this.cartTotal = parseInt(this.$el.dataset.cartTotal);
        this.hasReachedFreeShipping = this.cartTotal >= this.maxThreshold;
        this.hasReachedFreeGift = this.cartTotal >= this.freeGiftThreshold;
        this.updateProgress(this.cartTotal);
      },
      handleCartUpdate() {
        let newTotal = 0;

        // Get the latest cart state when items are added/removed/changed
        fetch(window.Shopify.routes.root + "cart.js")
          .then((response) => response.json())
          .then((cart) => {
            // Use items_subtotal_price which excludes discounts
            newTotal = cart.items_subtotal_price;
            this.cartTotal = newTotal;

            this.hasReachedFreeShipping = newTotal >= this.maxThreshold;
            this.hasReachedFreeGift = newTotal >= this.freeGiftThreshold;
            this.updateProgress(newTotal);
          })
          .catch((error) => {
            console.error("Error fetching cart:", error);
            // Fallback to existing total if fetch fails
            this.updateProgress(this.cartTotal);
          });
      },
      updateProgress(total) {
        this.hasReachedFreeShipping = total >= this.maxThreshold;
        this.hasReachedFreeGift = total >= this.freeGiftThreshold;
        this.progress = this.calculateProgressFromTotal(total);
      },
      calculateProgressFromTotal(total) {
        if (total === 0) return 0;
        return Math.min((total / this.maxThreshold) * 100, 100);
      },
      formatMoney(cents) {
        return new Intl.NumberFormat("de-DE", {
          style: "currency",
          currency: "EUR",
        }).format(cents / 100);
      },
    };
  });
});
